// extracted by mini-css-extract-plugin
export var connectionButton = "_a8-1";
export var rightPanel = "_a8-3";
export var stepDescription = "_a8-2";
export var stepIcon = "_a8-0";